import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getSocket } from "../../utils/socket";
import { toast } from "react-toastify";

const UserIncomingCall = () => {
  const { bookingId } = useParams();
  const navigate = useNavigate();
  const socket = getSocket();

  useEffect(() => {
    if (!socket) {
      toast.error("Socket not connected");
      navigate("/pickslot/my");
      return;
    }

    // Join call room
    socket.emit("join-call", {
      roomId: bookingId,
      role: "user",
    });

    // When vendor has started the call → auto redirect
    socket.on("vendor-started-call", ({ bookingId: id }) => {
      if (id === bookingId) {
        navigate(`/video/${bookingId}`);
      }
    });

    return () => {
      socket.off("vendor-started-call");
    };
  }, [bookingId, socket, navigate]);

  return (
    <div className="h-screen flex flex-col items-center justify-center bg-black text-white">
      <h2 className="text-2xl font-semibold mb-4">
        Incoming Video Call
      </h2>
      <p className="text-gray-400">
        Your expert has started the call…
      </p>
    </div>
  );
};

export default UserIncomingCall;
